import { EpimsBaseEntityDto } from './epim-base.dto';
export class LicenceStatusDto extends EpimsBaseEntityDto {
  LicenceStatusName: string;
  SubscriptionUserId: string;
  Version: number;
}
